import React from "react";
import "./buttonsContainer.css";
/**
 *
 * @param {number} gap Add additional spacing between buttons
 * @param {string} direction Change direction of the buttons between column and row
 * @example <ButtonsContainer gap={10} direction="column"> <GooglePlayButton/> <AppGalleryButton/> </ButtonsContainer>
 * @returns
 */
var ButtonsContainer = function ButtonsContainer(_ref) {
  var children = _ref.children,
    gap = _ref.gap,
    _ref$direction = _ref.direction,
    direction = _ref$direction === void 0 ? "row" : _ref$direction;
  return /*#__PURE__*/React.createElement("div", {
    className: "buttons-container",
    style: {
      gap: gap,
      flexDirection: direction
    }
  }, children);
};
export default ButtonsContainer;